import { Types } from './actions';
import {
  LogoMd,
  LogoCaixa,
  FaviconVR,
  FaviconCaixa,
  LogoCaixaHome,
} from '~/assets';
import { VRPAT, JVCEF } from '~/config/constants';

export const INITIAL_STATE = {
  issuer: null,
};

type issuerType = typeof VRPAT | typeof JVCEF;

type TypeAction = {
  type: string;
  name: issuerType;
};

const handleIssuer = (ctx: issuerType): Object => {
  const content = {
    [VRPAT]: {
      company: 'VR Benefícios',
      copyrightCompany: 'VR Benefícios',
      cnpj: '02.535.864/0001-33',
      head: {
        title: 'Portal do Trabalhador',
        favicon: FaviconVR,
      },
      logo: {
        alt:
          'Logo com fundo verde da VR Benefícios, com VR escrito em branco e centralizado e a palavra benefícios em branco na parte inferior.',
        src: LogoMd,
      },
      button: {
        primary: {
          style: 'primary',
        },
      },
      app: {
        name: 'VR e Você',
        android:
          'https://play.google.com/store/apps/details?id=ws.hanzo.Vrrh&hl=pt_BR',
        ios: 'https://apps.apple.com/br/app/vr-e-voc%C3%AA/id667577139',
      },
      phones: [
        {
          type: 'whatsapp',
          href:
            'https://api.whatsapp.com/send?phone=551140044938&text=Ol%C3%A1',
          label: 'WhatsApp',
          value: '011 4004-4938',
          icon: ['fab', 'whatsapp'],
        },

        {
          type: 'phone1',
          href: 'tel:+551140044938',
          label: 'Regiões metropolitanas',
          value: '011 4004-4938',
          icon: ['fal', 'phone-alt'],
        },
        {
          type: 'phone2',
          href: 'tel:+5508005963838',
          label: 'Demais localidades',
          value: '0800 596-3838',
          icon: ['fal', 'phone-alt'],
        },
        {
          type: 'link',
          href: 'https://qrco.de/bflD8X',
          label: 'Se você é trabalhador',
          value: 'baixe o SuperApp VR clicando aqui',
          icon: ['fal', 'mobile'],
        },
      ],
      terms: {
        privacity: {
          name: 'Políticas de Privacidade',
          value: 'https://www.vr.com.br/politica-de-privacidade.htm',
        },
        use: {
          name: 'Termos de uso',
          value: 'https://www.vr.com.br/termos-de-uso.htm',
        },
      },
    },
    [JVCEF]: {
      company: 'CAIXA Pré-Pagos',
      copyrightCompany: 'CAIXA Cartões Pré-Pagos S.A',
      cnpj: '39.459.331/0001-20',
      head: {
        title: 'Portal da Caixa',
        favicon: FaviconCaixa,
      },
      logo: {
        alt: 'Logo da caixa representado por um x.',
        src: LogoCaixa,
        src2: LogoCaixaHome,
      },
      button: {
        primary: {
          style: 'caixa',
        },
      },
      app: {
        name: 'CAIXA Refeição e Alimentação',
        android: 'https://play.google.com/store/apps/details?id=ws.hanzo.JVCEF',
        ios: 'https://apps.apple.com/us/app/caixa-vr-e-va/id1610166700',
      },
      phones: [
        {
          type: 'whatsapp',
          href:
            'https://api.whatsapp.com/send?phone=551130039590&text=Ol%C3%A1',
          label: 'WhatsApp',
          value: '011 3003-9590',
          icon: ['fab', 'whatsapp'],
        },
        {
          type: 'phone1',
          href: 'tel:+551130039590',
          label: 'Regiões metropolitanas',
          value: '011 3003-9590',
          icon: ['fal', 'phone-alt'],
        },
        {
          type: 'phone2',
          href: 'tel:+5508005963838',
          label: 'Demais localidades',
          value: '0800 721 9590',
          icon: ['fal', 'phone-alt'],
        },
      ],
      terms: {
        privacity: {
          name: 'Aviso de privacidade',
          value: 'https://www.caixaprepagos.com.br/aviso-de-privacidade.html',
        },
        use: {
          name: 'Termos de uso',
          value: '/termos-de-uso.html',
        },
      },
    },
  };

  return content[ctx];
};

export default function issuer(state = INITIAL_STATE, action: TypeAction) {
  switch (action.type) {
    case Types.SET: {
      return {
        name: action.name,
        ...handleIssuer(action.name),
      };
    }
    default:
      return state;
  }
}
